import { createContext } from "react";

export const HtmlCodeExtractedContext = createContext();